import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter
} from '@jutro/components';
import messages from 'sg-common-messages';

function SgConfirmationModalCtrl(props) {
    const {
        title,
        cancelBtnLabel,
        confirmBtnLabel,
        isOpen,
        onResolve,
        onReject,
        className,
        message,
    } = props;

    const cancelLabel = _.isEmpty(cancelBtnLabel) ? messages.ModalMessageCancel : cancelBtnLabel;
    const confirmLabel = _.isEmpty(confirmBtnLabel) ? messages.ModalMessageConfirm : confirmBtnLabel;

    return (
        <ModalNext isOpen={isOpen}>
            <div className={`${className} sgConfirmationModal`}>
                <img id="sagaLogo" alt="Saga Logo" className="logoImage" src="https://asset.saga.co.uk/common/brand2021/logo/Saga_Logo_Indigo.svg" />
                <ModalHeader title={title} />
                <ModalBody>
                    {message}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onReject} className="sgButton sgSecondaryButton">
                        {cancelLabel}
                    </Button>
                    <Button onClick={onResolve}>
                        {confirmLabel}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

SgConfirmationModalCtrl.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func
};

SgConfirmationModalCtrl.defaultProps = {
    isOpen: true,
    onReject: () => {},
    onResolve: () => {}
};

export default SgConfirmationModalCtrl;
